module.exports = __webpack_public_path__ + "static/img/cop_sch_logo26.13ae244a.png";